import BaseStore from '../Base'
import {Actions} from './Constants'

import sjcl from 'sjcl'
import {UserStore} from '../user'

class AuthStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))
      this._auth = null
      this._authenticated = null
   }

   _subscribe(action) {
      switch (action.actionType) {
         case Actions.login:
            this._auth = action.auth
            this._authenticated = true
            this.emitChange()
            break

         case Actions.logout:
            this._auth = null
            this._authenticated = false
            this.emitChange()
            break

         default:
            break
      }
   }

   get auth() {
      return this._auth
   }

   haveAuthentication() {
      return null !== this._auth
   }

   get isAuthenticated() {
      // null := have authentication but no response from server yet
      return this._authenticated
   }

   canAccess(type, resource) {
      if (null === resource) {
         return null
      }

      switch (type) {
         // check if myself, or any of my organizations, are defined in network parents
         case 'network':
            if (-1 !== _.indexOf(resource.parents, this.auth.owner)) {
               return true
            } else if (!UserStore.user) {
               // don't know anything about the user yet yet
               return null
            } else {
               return _.some(
                  UserStore.user.organizations,
                  ({key}) => -1 !== _.indexOf(resource.parents, `organization/${key}`),
               )
            }

         case 'device':
            return this.canAccess('network', NetworkStore.network(resource.network))

         default:
            return false
      }
   }

   signV1(method, url, body, userauth) {
      const auth = userauth || this._auth

      if (!auth) {
         return null
      }

      let hmac = new sjcl.misc.hmac(sjcl.codec.utf8String.toBits(auth.key)),
         digest = hmac.mac([method || '', url || '', body || ''].join('\n'))

      return auth.fingerprint + ' ' + sjcl.codec.base64.fromBits(digest)
   }
}

export default new AuthStore()



// WEBPACK FOOTER //
// lib/api/auth/Store.js